export default __webpack_public_path__ + "static/media/Tijofi-TS5.19f39931.jpg";